import React from 'react';
import { Link, Route, Switch, NavLink } from 'react-router-dom';
import UsersList from './UsersList';
import UsersForm from './FormsIndex';
import EditUserForm from './FormEditIndex';
import userEditFrom from './UsersForm';
import Content from '../../../_psb/layout/Content';
import SubHeader from '../../../_psb/layout/sub-header/SubHeader';
import Search from '../../../components/form/Search';
import { setSearchValueAction } from '../../../modules/users/Actions';
import { connect } from 'react-redux';
import { searchValueSelector } from '../../../modules/users/Selectors';
import AdminsForm from './AdminsForm';
import {
  authCurrentDefaultTypeSelecetor,
  authCurrentUserSelector
} from '../../../modules/auth/Selectors';
import TrainingCenterForm from './TrainingCenterFrom';
import ApplicantForm from './ApplicantForm';
import AdminsRoute from '../../router/AdminsRoute';
import SuperAdminRoute from '../../router/SuperAdminRoute';
import getLangData from '../../../utils/getLangData';
const users = props => {
  const { defaultUserType, setSearchValue, searchValue, user } = props;
  return (
    <>
      <SubHeader
        title={getLangData().menu.side.users}
        Component={() => (
          <>
            <Switch>
              {/* <Route
                exact
                path='/users'
                // path='/commented'
                component={() => {
                  return (
                    <>
                      <span className='kt-subheader__separator kt-subheader__separator--v'></span>
                      <Search
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                      />
                    </>
                  );
                }}
              /> */}
            </Switch>
          </>
        )}
      >
        <Switch>
          <Route
            exact
            path='/users'
            component={() => {
              return (
                <>
                  {/* {user.userType.includes('0') ? ( */}
                  {defaultUserType === '0' ? (
                    <div>
                      {' '}
                      <Link
                        to='/users/admins/create'
                        className='btn btn-primary'
                      >
                        {getLangData().buttons.add_admin}
                      </Link>
                      <Link
                        to='/users/create'
                        className='btn btn-primary'
                        style={{ marginLeft: '10px', marginRight: '10px' }}
                      >
                        {getLangData().buttons.add_user}
                      </Link>
                    </div>
                  ) : (
                    <Link
                      to='/users/create'
                      className='btn btn-primary'
                      style={{ marginLeft: '10px' }}
                    >
                      {getLangData().buttons.add_new}
                    </Link>
                  )}
                </>
              );
            }}
          />
          {/* <Route
            exact
            path="/users"
            component={() => (
              <Link to="/users/create" className="btn btn-primary">
                Add New{' '}
              </Link>
            )}
          /> */}

          {/* <Route
            exact
            path={["/users/create", "/users/:id"]}
            component={() => {
              return (
                <Link to='/users' className='btn-label-brand btn btn-bold'>
                  Back To List{" "}
                </Link>
              );
            }}
          /> */}
        </Switch>
      </SubHeader>
      <Content>
        {/**
         * Wizard
         */}

        <Switch>
          <AdminsRoute exact path='/users' component={UsersList} />

          {/** Create */}
          <AdminsRoute exact path='/users/create' component={UsersForm} />

          {/* <Route exact path="/users/create" component={TrainingCenterForm} /> */}

          <SuperAdminRoute
            exact
            path='/users/admins/create'
            component={AdminsForm}
          />
          {/** End Create  */}

          {/** Edit */}
          {/* <Route exact path='/users/:id' component={UsersForm} /> */}
          <AdminsRoute exact path='/users/:id' component={EditUserForm} />
        </Switch>
      </Content>
    </>
  );
};

const mapStateToProps = state => ({
  searchValue: searchValueSelector(state),
  user: authCurrentUserSelector(state),
  defaultUserType: authCurrentDefaultTypeSelecetor(state)
});
const mapDispatchToProps = {
  setSearchValue: setSearchValueAction
};
export default connect(mapStateToProps, mapDispatchToProps)(users);
